import { client } from 'lib/apollo';

import { EVENT, EVENT_CONFIRMED_MEMBERS, EVENT_INVITED_MEMBERS } from './query';

export const getEvent = (id: string) =>
    client.query({
        query: EVENT,
        variables: {
            id,
        },
    });

export const getEventConfirmedMembers = (id: string, after?: string) =>
    client.query({
        query: EVENT_CONFIRMED_MEMBERS,
        variables: {
            id,
            after,
        },
    });

export const getEventInvitedMembers = (id: string, after?: string) =>
    client.query({
        query: EVENT_INVITED_MEMBERS,
        variables: {
            id,
            after,
        },
    });
